module.exports = __webpack_public_path__ + "img/c1.63054bbd.png";